import React from 'react'

import {GetStaticProps} from 'next'

import SEO from 'components/elements/SEO'
import LayoutHome from 'components/layouts/LayoutHome'
import TemplateCreateDocumentW2 from 'components/templates/TemplateCreateDocumentW2'
import sanityClient from 'src/backend/lib/sanityClient'
import {TPageComponent} from 'src/types'
import {W2Page} from 'src/types/__sanitySchema__'
import {getKeywords} from 'src/utils'

export interface IW2Content extends W2Page {}

interface IW2Props {
	pageContent: IW2Content
}

const W2: TPageComponent<IW2Props> = ({pageContent}) => {
	return (
		<>
			<SEO
				title={pageContent?.seo?.seo_title || pageContent?.title}
				description={pageContent?.seo?.meta_description}
				keywords={getKeywords(pageContent?.seo?.focus_keyword, pageContent?.seo?.focus_synonyms)}
			/>
			<TemplateCreateDocumentW2 content={pageContent} />
		</>
	)
}

W2.displayName = 'W2'
W2.Layout = LayoutHome

export const getStaticProps: GetStaticProps<IW2Props> = async () => {
	try {
		const w2Content = (
			await sanityClient.fetch<W2Page[]>(`*[_type == "w2Page"]{
			...,
			users{
				...,
				items[]{
					...,
					"icon": icon.asset->url
				}
			},
			tipsWhenSeveral{
				...,
				items[]{
					...,
					"icon": icon.asset->url
				}
			}
		}`)
		)[0]
		return {
			props: {
				pageContent: w2Content,
			},
		}
	} catch {
		return {
			notFound: true,
		}
	}
}

export default W2
